import React from "react"
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	TextField,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	Box,
} from "@material-ui/core"

import {api} from "@indebted/api"
import {useNotification} from "@indebted/components/Notification"
import {useAgent} from "@indebted/hooks/Agent"

type RevokeOfferModalProps = {
	customerID: string
	offerID: string
	open: boolean
	onClose: () => void
	onSuccess: () => void
}

function RevokeOfferModal({customerID, offerID, open, onClose, onSuccess}: RevokeOfferModalProps) {
	const {notification} = useNotification()
	const [agentEmail] = useAgent()
	const [revoking, setRevoking] = React.useState(false)
	const [reason, setReason] = React.useState("INCORRECT_CONFIGURATION")
	const [notes, setNotes] = React.useState("")

	const handleConfirm = async () => {
		setRevoking(true)
		try {
			await api.customer.revokeOffer(customerID, offerID, {
				Reason: reason,
				AgentEmail: agentEmail,
				Notes: notes || undefined,
			})
			notification.success("Offer revoked successfully")
			onSuccess()
		} catch (error: any) {
			notification.error(error.Message || "Failed to revoke offer")
		} finally {
			setRevoking(false)
		}
	}

	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
			<DialogTitle>Revoke Offer</DialogTitle>
			<DialogContent>
				<DialogContentText>
					Are you sure you want to revoke this offer? This action cannot be undone.
				</DialogContentText>
				<Box mt={3}>
					<FormControl fullWidth variant="outlined" margin="normal">
						<InputLabel id="reason-label">Reason</InputLabel>
						<Select
							labelId="reason-label"
							value={reason}
							onChange={(e) => setReason(e.target.value as string)}
							label="Reason"
							disabled={revoking}
						>
							<MenuItem value="INCORRECT_CONFIGURATION">Incorrect Configuration</MenuItem>
						</Select>
					</FormControl>
					<TextField
						fullWidth
						multiline
						rows={3}
						label="Notes (optional)"
						variant="outlined"
						margin="normal"
						value={notes}
						onChange={(e) => setNotes(e.target.value)}
						disabled={revoking}
					/>
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} disabled={revoking} color="secondary">
					Cancel
				</Button>
				<Button onClick={handleConfirm} color="primary" disabled={revoking}>
					{revoking ? "Revoking..." : "Revoke"}
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export {RevokeOfferModal}
